import { createApp } from 'vue'
import router from './router'
import App from './App.vue'

import apiClient from '@/api/client';

const app = createApp(App);

// This makes it available as this.$apiClient in Options API
app.config.globalProperties.$apiClient = apiClient;

app.use(router).mount('#app')
